import { getSupabaseBaseUrl, getSupabasePublishableKey } from '@/lib/selfHostedUrls';
import { createGovernedBrowserClient } from './portalClientFactory';

const SUPABASE_URL = getSupabaseBaseUrl();
const SUPABASE_PUBLISHABLE_KEY = getSupabasePublishableKey();

// Separate Supabase client for ForkSeek portal with an isolated storage key.
// This prevents session conflicts when an employer and candidate are logged
// in simultaneously on the same domain in different browser tabs.
export const seekSupabase = createGovernedBrowserClient(
  'seek',
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
);
